module.exports = __webpack_public_path__ + "media/images/gallery/dn_off-f40b4cd3d5ec82fea35ae9212fc8bed4.gif";